import { type RefObject, useEffect } from "react";

export function useAutoFocus(ref: RefObject<HTMLElement | null>, autoFocus: boolean) {
  useEffect(() => {
    if (!autoFocus || !ref.current) {
      return;
    }

    const id = window.setTimeout(() => ref.current?.focus(), 300);
    return () => window.clearTimeout(id);
  }, [autoFocus, ref]);
}
